import { CircularProgress } from "@material-ui/core";
import { MyLocation } from "@material-ui/icons";
import { useCallback, useEffect, useState } from "react";
import { Button, ResettableTextField } from "react-admin";
import { MasterEventApiFactory } from "../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";

interface Props {
  onGeolocationFound: (coordinates?: Coordinates) => void;
}

export interface Coordinates {
  lat: number;
  lng: number;
}

export const EventLocationSearch = ({ onGeolocationFound }: Props) => {
  const [searchText, setSearchText] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [reset, setReset] = useState<boolean>(true);
  const axios = useAxiosInstance();

  const handleGeolocationSearch = useCallback(
    (searchText: string) => {
      if (!axios) {
        return;
      }

      setLoading(true);
      MasterEventApiFactory(undefined, axios.defaults.baseURL, axios)
        .apiAppMastereventBestcoordinatesbygeolocationGet(searchText)
        .then((response) => {
          setReset(true);
          if (!response.data) {
            return;
          }

          onGeolocationFound(response.data);
        })
        .finally(() => setLoading(false));
    },
    [axios, onGeolocationFound]
  );

  useEffect(() => {
    if (!reset) {
      return;
    }

    if (searchText === "") {
      onGeolocationFound(undefined);
      setReset(false);
    }
  }, [reset, searchText, onGeolocationFound]);

  return (
    <>
      <ResettableTextField
        source="q"
        label="Search by geolocation"
        variant="outlined"
        margin="dense"
        autoFocus
        value={searchText}
        onChange={(e) => setSearchText(e.target.value ?? "")}
        resettable
      />
      <Button
        label=""
        variant="outlined"
        color="default"
        onClick={() => handleGeolocationSearch(searchText)}
        disabled={loading}
      >
        {loading ? <CircularProgress size={16} /> : <MyLocation />}
      </Button>
    </>
  );
};
